import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "CustomIntervalstyles__Container",
  componentId: "keen-query-creator__sc-1na2w5s-0"
})(["&&&{padding:14px;min-height:110px;box-sizing:border-box;}"]);